const
  NAME                 = 'selectDisplay',
  VERSION              = '1.0.0',
  JQUERY_NO_CONFLICT   = $.fn[NAME]
;

var _selectedId;

class SelectDisplay {
  constructor(element$) {
    var select$;

    this._element$ = element$;
    select$        = element$.find('select');
    _selectedId    = select$.find('option:selected').val();
    $(`#${_selectedId}`, element$).addClass('voc-visible-select-div');

    select$.on('change', this.onChange.bind(this));
  }

  onChange(event) {
    _selectedId = event.target.value;
    $('.voc-select-div', this._element$).removeClass('voc-visible-select-div');
    $(`#${_selectedId}`, this._element$).addClass('voc-visible-select-div');
  }

  static get VERSION() {
    return VERSION;
  }

  static _jQueryInterface() {
    return this.each(function() {
      new SelectDisplay($(this));
    });
  }
}

$.fn[NAME]             = SelectDisplay._jQueryInterface;
$.fn[NAME].Constructor = SelectDisplay;
$.fn[NAME].noConflict  = function noConflict() {
  $.fn[NAME] = JQUERY_NO_CONFLICT;
  return SelectDisplay._jQueryInterface;
};

export default SelectDisplay;



// WEBPACK FOOTER //
// ./src/plugins/select-display.js